import { css } from '@emotion/core';

export const customerStatFilterByCustomerIdDivCSS = (theme) => `
    display: inline-block;
    ${
        theme.mobile
            ? `width: 100%;
            padding-bottom: 1rem;
            border-bottom: 0.063rem solid ${theme.colors.neutral80};`
            : `width: 15.75rem;
            padding-right: 1rem;`
    }
`;

export const selectedRadioCSS = ({ colors }) => css`
    background-color: ${colors.whiteBackgroundColorActive};
    background-clip: content-box;
    margin-top: 0.4rem;
    cursor: pointer;
    border-radius: 0.25rem;
`;

export const customStatFilterRadioCSS = (theme) => `
    display: flex;
    flex-direction: column;
    padding-bottom: 0.3rem;
    border-collapse: separate;
    border-spacing: 0;

    tbody {
        display: block;
        height: 100%;
    }

    tbody tr {
        width: 100%;
        display: inline-table;
    }
    
    tr,
    td {
        vertical-align: middle;
    }
    
    tr {
        height: 2.5rem;
    }

    td {
        ${
            theme.mobile
                ? `
        text-align: left;
        // this is to add padding in between radio and text elements
        &:nth-of-type(1) { 
            width: 5%;
            align-content: flex-start;
            padding-left: 0.25rem;
            padding-top: 0.1rem;
        }
        &:nth-of-type(2) {
            padding-left: 0.25rem;
            align-content: normal;
            word-break: break-all;
        }
        &:nth-of-type(3) {
            padding-left: 0.5rem;
            white-space:nowrap;
            align-content: flex-start;
            padding-top: 0.25rem;
        }`
                : `
        &:nth-of-type(1) {
            width: 1.25rem;
            height: 1.5rem;
            align-content: flex-start;
            padding-left: 0.25rem;
            padding-top: 0.1rem;
        }
        &:nth-of-type(2) {
            padding-left: 0.5rem;
            word-break: break-all;
            align-content: normal;
        }
        &:nth-of-type(3) {
            padding-left: 0.5rem;
            white-space:nowrap;
            align-content: flex-start;
            padding-top: 0.25rem;
        }`
        }; 
    }
`;

export const customerStatFilterEditDeleteCSS = css`
    padding-right: 0.5rem;
    float: right;
    display: inline-block;
`;

export const deleteSpanCSS = css`
    padding-left: 0.25rem;
`;

export const customerStatFilterRadioCSS = ({ colors }) => css`
    width: 90%;
    margin-top: 0.4rem;
    border-radius: 0.25rem;
    cursor: pointer;
    &:active,
    &:hover,
    &:focus {
        background-color: ${colors.whiteBackgroundColorActive};
        span {
            opacity: 1;
        }
        background-clip: content-box;
    }
`;

export const statFilterTableHeadingCSS = ({ colors }) => css`
    width: 100%;
    padding-left: 0.25rem;
    font-weight: bold;
    color: ${colors.textSecondary};
`;

export const customerStatFilterButtonsCSS = ({ colors }) => css`
    cursor: pointer;
    border-radius: 50%;
    height: 2rem;
    width: 2rem;
    border-color: transparent;
    background-color: transparent;
    padding: unset;

    &:hover,
    &:active {
        background-color: ${colors.hoverBackground};
    }

    > svg {
        color: ${colors.neutral10};
    }
`;
export const customerStatFilterEditDeleteHiddenCSS = css`
    float: right;
    opacity: 0;
    transition: opacity 0.2s ease;
    display: inline-block;
    padding-right: 0.5rem;
`;

export const customerStatFilterDisabledButtonsCSS = ({ colors }) => css`
    color: ${colors.disabledLightGrey};
    border-radius: 50%;
    height: 1.5rem;
    width: 1.5rem;
    border-color: transparent;
    background-color: transparent;
    padding: unset;
`;

export const customerStatFilterPopConfirmCSS = ({ fontSizes }) => css`
    font-size: ${fontSizes.small};
`;
